<template>
    <div class="Brand">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="page" textColor="#000" title="" />
            <div class="brandContent">
                <div class="topCitation">
                    il futuro entra in noi, per trasformarsi in noi, molto prima di essere accaduto. 
                    <br>- Rainer Maria Rilke, <i>Lettere a un giovane poeta</i>
                    </div>
                <div class="container">
                    <div class="brandColumns columns descriptionText has-text-justified">
                        <div class="brandColumn column is-4">
                            <b>Graziella Bordone</b>, ha sempre creduto nei viaggi e nel futuro,
                            da amministrativa diventa preseller dei programmi gestionali.
                            Oggi è il punto di riferimento
                            per tutti i clienti,
                            nonchè il motore del cambiamento della nuova visione di page93.
                            <br><br>

                            <div class="citationContainer">
                                <span class="citation">
                                    "le massime prestazioni dei nostri servizi sono il risultato della ricerca, della
                                    dinamicità e dell'innovazione"
                                </span>
                            </div>
                        </div>
                        <div class="brandColumn column is-4">
                            <b>Roberto Molino</b>, appassionato sommelier, comincia come programmatore per diventare il
                            vero conoscitore
                            delle aziende e il risolutore delle problematiche della gestione.
                            <br><br>

                            <div class="citationContainer">
                                <span class="citation">
                                    "faccio questo lavoro perchè mi permette di costruire il futuro degli altri"
                                </span>
                            </div>
                        </div>
                        <div class="brandColumn column is-4">
                            <b>Giorgio Vacchetto</b>, campione di pallone elastico, entra come tecnico e diventa il
                            responsabile commerciale
                            per la parte tecnica sistemistica.
                            <br><br>

                            <div class="citationContainer">
                                <span class="citation">
                                    "il nostro è un gioco di squadra e questa è la nostra forza"
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="missionContent">
            <div class="missionText">
                <p>
                    La mission di <b>page93®</b> rappresenta it contributo di Graziella Bordone, Roberto Molino
                    e Giorgio Vacchetto alla crescita positiva delta società contemporanea e delle generazioni future.
                    <br><br>
                    <b>page93®</b> è innovazione nel mondo del sistemi di gestione, testimonia responsabilità e
                    desiderio di rivoluzione.
                    <br><br>
                    ogni progetto <b>page93®</b> garantisce alta qualità, assoluta sicurezza e innovazione nelle
                    dinamiche gestionali.
                    <br><br>
                    <b>page93®</b> contribuisce a realizzare il futuro delle aziende.
                </p>
            </div>
            <div class="futureImage"></div>
            <div class="square">
                <span>capire le imprese</span>
                <span>risolvere i problemi</span>
                <span>innovare per realizzare il futuro</span>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'Brand',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .Brand {
        width: 100%;

        .pageContent {
            width: 100%;
            min-height: 55vh; //temp
            position: relative;
            color: #000;

.topCitation
{
        position: absolute;
    right: 25px;
    top: 50px;
    width: 35vw;
    padding: 20px;
    border: 2px solid #000;
    font-weight: 500;
    color: #fff;
    background-color: #000;

    
                @media only screen and (max-width: 768px) {
    width: 55vw;
                }

                
                @media only screen and (max-width: 575px) {
    display: none;
                }
}

            .brandContent {
               // margin-top: 8%;
               margin-bottom: 50px;
            }

            .brandColumns {

                .brandColumn {
                    padding: 35px;

                    .citationContainer {
                        margin-left: 25%;
                    }

                    .citation {
                        font-style: italic;
                        font-size: 0.9rem;
                    }
                }

            }

            /*  .brandContent {
                display: grid;
                grid-template-columns: repeat(8, 1fr);
                grid-template-rows: repeat(5, 1fr);
                grid-column-gap: 0px;
                grid-row-gap: 0px;
                height: 100%;
                min-height: 100vh;

                .bgColor {
                    grid-area: 1 / 1 / 6 / 4;
                    background-color: #727948;
                }

                .descriptionBox
                {
                    grid-area: 2 / 4 / 5 / 9;
                }
            }*/

            .parTitle {
                font-weight: 900;
                font-size: 26px;
            }

            .infoContainer {
                display: flex;
                // height: 100%;
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 400;
                text-align: left;
                text-align: justify;

                @media only screen and (min-width: 768px) {
                    margin-right: 30px;
                    margin-top: 20px;
                }
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {

                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }
        }

        .missionContent {
            min-height: 80vh; //temp
            background-color: #9694e7;
            color: #fff;

            display: grid;
            grid-template-columns: 20px repeat(2, 1fr) 20px repeat(3, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;

            @media only screen and (min-width: 1600px) {
                display: grid;
                grid-template-columns: 20px repeat(3, 1fr) 40px repeat(6, 1fr);
                grid-template-rows: repeat(7, 1fr);
                grid-column-gap: 0px;
                grid-row-gap: 0px;
            }

            @media only screen and (max-width: 889px) {
                display: flex;
                flex-direction: column;
                min-height: auto;
            }

            .missionText {
                grid-area: 2 / 2 / 5 / 4;
                font-size: 20px;
                text-align: justify;
                padding: 40px;
                line-height: 35px;
                margin-top: -100px;

                @media only screen and (min-width: 1600px) {
                    grid-area: 2 / 3 / 7 / 5;
                    margin-top: 0;
                }

                @media only screen and (max-width: 889px) {
                    margin-top: 0;
                    line-height: 25px;
                    padding: 20px;
                }
            }

            .square {
                grid-area: 2 / 5 / 4 / 7;
                border: 4px solid #fff;
                z-index: 2;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                padding: 20px;
                font-weight: 900;
                font-size: 2rem;
                padding-right: 50%;
                font-style: italic;


                @media only screen and (min-width: 1600px) {
                    grid-area: 3 / 7 / 6 / 9;
                }

                @media only screen and (max-width: 889px) {
                    grid-area: 2 / 8 / 6 / 10;
                    font-size: 1.2rem;
                    padding: 20px;
                    margin: 20px;
                    background: url("../assets/images/brand1.jpg");
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: cover;
                }
            }

            .futureImage {
                grid-area: 1 / 6 / 5 / 8;
                background: url("../assets/images/brand1.jpg");
                z-index: 1;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                background-attachment: fixed;

                @media only screen and (min-width: 1600px) {
                    grid-area: 1 / 8 / 8 / 12;
                }

                @media only screen and (max-width: 889px) {
                    display: none
                }
            }
        }
    }
</style>